import Solicitation from './Solicitation';

export default Solicitation;
